import Vue from 'vue';
import Util from '@/util';

Vue.filter('toDate', Util.toDate);
Vue.filter('toDatetime', Util.toDatetime);
Vue.filter('sapDataToFullname', Util.sapDataToFullname);
Vue.filter('sapDataToBirthdate', Util.sapDataToBirthdate);
Vue.filter('sapDataToStreet', Util.sapDataToStreet);
Vue.filter('sapDataToCity', Util.sapDataToCity);
